import React from 'react';
import "../styles/BaseLayout.scss"
import {Outlet, useNavigate} from "react-router";
import SideBar from "../components/SideBar";
import {ModalProvider} from "../Contexts/Modal";

export default function AppLayout() {
    const navigate = useNavigate();

    return (
        <ModalProvider>
            <div className={"flex-row space-between litle-margin"}>
                <h2 className={"title"} onClick={() => navigate('/')}>Pro des notes</h2>
                <h2 className={"pointer"} onClick={() => navigate('/auth/login')}>Deconnexion</h2>
            </div>
            <div style={{display: "flex"}}>
                <SideBar/>
                <div style={{flex: 1}}>
                    <Outlet/>
                </div>
            </div>
        </ModalProvider>
    );
}

